





















import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// The base for every action
import ActionBase from './ActionBase.vue';

/**
 *
 *  The carrot icon to invoke a toggle action.
 *
 *  (i) Also reflects the provided open state
 *
 */
@Component
export default class ActionToggle extends ActionBase {

    @Prop({ type: Boolean, required: true })
    private open!: boolean;

}
